export var admin = {
    900: '#C30017',
    800: '#D20024',
    700: '#E0072B',
    600: '#F21B31',
    500: '#FF2931',
    400: '#FD414C',
    300: '#F16A70',
    200: '#F89599',
    100: '#FFCBD2',
    50: '#FFEAEE',
};
//# sourceMappingURL=admin.js.map